import { isAFullName } from "./isAFullName";
import { TFullName } from "./nameLiterals";

export const fullNameToTuple = (fullName: TFullName) =>
    fullName
        .split(/\s|\./)
        .filter((a) => !!a)
;